<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Hourglass" class="d-icon d-icon--hourglass" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 10.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1H9V8.914a1.5 1.5 0 0 0-.44-1.06L6.707 6l1.854-1.853A1.5 1.5 0 0 0 9 3.086V1.5h.5a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1H3v1.586c0 .398.158.78.44 1.06L5.292 6 3.439 7.853A1.5 1.5 0 0 0 3 8.914V10.5h-.5ZM4 3.086a.5.5 0 0 0 .146.353L6 5.293l1.853-1.854A.5.5 0 0 0 8 3.086V1.5H4v1.586ZM7.854 8.56A.5.5 0 0 1 8 8.914V10.5H4V8.914a.5.5 0 0 1 .147-.353L6 6.707l1.854 1.854Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconHourglass',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
